import { useMutation } from 'react-query';
import axios from 'axios';

import api from '@src/utils/api';
import { UPLOAD_ASSETS } from '@src/hooks/react-query/queries';

const uploadToPresignedUrl = ({ presignedUrl, file }) => {
  // using raw axios here because the "default" middlewares should not be applied to this request
  return axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': file.type,
      'x-amz-acl': 'public-read',
    },
  });
};

export const useUploadToPresignedUrl = () => useMutation(uploadToPresignedUrl);

const fetchUploadPresignedUrl = (payload) => {
  const { asset_type, mimeType, extension } = payload;
  return api.post(`${UPLOAD_ASSETS}?asset_type=${asset_type}`, { mimeType, extension });
};

export const useFetchUploadPresignedUrl = (payload) => {
  return useMutation(
    [`${UPLOAD_ASSETS}?asset_type=${payload?.asset_type}`],
    fetchUploadPresignedUrl
  );
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useAssetUpload.js